import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { SectionHeading } from './ui/SectionHeading';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    text: 'La atención es inmejorable. Desde la primera consulta me sentí escuchada y comprendida. Los resultados de mi tratamiento facial superaron mis expectativas, luciendo completamente natural.',
    author: 'María Fernández',
    treatment: 'Rejuvenecimiento Facial'
  }, {
    text: 'Un equipo de verdaderos profesionales. Las instalaciones son preciosas y transmiten mucha paz. El tratamiento corporal me ha devuelto la confianza en mí misma.',
    author: 'Elena Gómez',
    treatment: 'Body Contouring'
  }, {
    text: 'Llevaba años buscando una clínica de confianza para tratar mis manchas. La tecnología que utilizan es increíble y el seguimiento médico me dio mucha tranquilidad.',
    author: 'Carmen Ruiz',
    treatment: 'Tecnología Láser'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const next = () => {
    setCurrentIndex(prev => (prev + 1) % testimonials.length);
  };
  const prev = () => {
    setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  };
  return <section id="testimonios" className="py-24 md:py-32 bg-background" data-id="element-231">
      <div className="container mx-auto px-6 md:px-12" data-id="element-232">
        <SectionHeading title="Lo que dicen nuestros pacientes" data-id="element-233" />

        <div className="max-w-4xl mx-auto mt-16 relative" data-id="element-234">
          <FadeIn data-id="element-235">
            <div className="bg-surface rounded-3xl p-10 md:p-16 border border-border shadow-sm text-center relative" data-id="element-236">
              <Quote className="w-12 h-12 text-gold/20 mx-auto mb-8" data-id="element-237" />

              <div className="min-h-[160px] flex items-center justify-center" data-id="element-238">
                <p className="font-serif text-2xl md:text-3xl text-foreground leading-relaxed italic" data-id="element-239">
                  "{testimonials[currentIndex].text}"
                </p>
              </div>

              <div className="mt-10" data-id="element-240">
                <h4 className="font-medium text-foreground tracking-wide uppercase text-sm" data-id="element-241">
                  {testimonials[currentIndex].author}
                </h4>
                <p className="text-gold text-sm mt-1" data-id="element-242">
                  {testimonials[currentIndex].treatment}
                </p>
              </div>

              {/* Controls */}
              <div className="absolute top-1/2 -translate-y-1/2 left-0 right-0 flex justify-between px-4 md:-mx-6 pointer-events-none" data-id="element-243">
                <button onClick={prev} className="w-12 h-12 rounded-full bg-background border border-border flex items-center justify-center text-foreground hover:text-gold hover:border-gold transition-colors pointer-events-auto shadow-sm" data-id="element-244">
                  <ChevronLeft className="w-6 h-6" data-id="element-245" />
                </button>
                <button onClick={next} className="w-12 h-12 rounded-full bg-background border border-border flex items-center justify-center text-foreground hover:text-gold hover:border-gold transition-colors pointer-events-auto shadow-sm" data-id="element-246">
                  <ChevronRight className="w-6 h-6" data-id="element-247" />
                </button>
              </div>
            </div>

            {/* Indicators */}
            <div className="flex justify-center gap-3 mt-8" data-id="element-248">
              {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-gold w-8' : 'bg-border hover:bg-gold/50'}`} data-id="element-249" />)}
            </div>
          </FadeIn>
        </div>
      </div>
    </section>;
}